import React, { useState } from "react";
import ParagraphTag from "../reusebale/Paragraph";
import Signature from "../dashboard-section/profile-complete/signIn-lease/DigitalSignature";
import { ShowSuccess, ShowError } from "../../utils/ToasFunction";
import BaseUrl from "../../constants/BaseUrl";
import ButtonTag from "../reusebale/button";
import { CircleX } from "lucide-react";

const SignPopup = ({ onClose, onSubmit }) => {
  const [signatureLoading, setSignatureLoading] = useState(false);
  const [isSignature, setIsSignature] = useState(false);
  const [signatureImg, setSignatureImg] = useState();

  const ConvertSignatureToUrl = (file) => {
    setSignatureLoading(true);
    const formdata = new FormData();
    formdata.append("image", file);

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `https://api.dev.theflexmanager.com/api/uploads/upload`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.url) {
          ShowSuccess("Signature save successfully.");
          setSignatureImg(result);
          setSignatureLoading(false);
          setIsSignature(true);
        } else {
          setSignatureLoading(false);
          ShowError("Oops! something went wrong");
        }
      })
      .catch((error) => console.error(error));
  };
  return (
    <main className="w-full h-screen backdrop-blur-sm bg-black/80 fixed inset-0 z-50 flex items-center justify-center">
      <section className="w-[90%] sm:w-[65%] md:w-[50%] lg:w-[40%] xl:w-[50%] 2xl:w-[40%] bg-texture myshades rounded-[31px] mx-auto">
        <div class="bg-white py-8 relative lg:py-5 rounded-xl justify-center items-center flex flex-col">
          <div className="">
            <div>
              <ParagraphTag
                content="Signature"
                classes={`text-darkColor font-popinsSemiBold text-sm `}
              />
            </div>
            <div className="absolute top-3 right-4 cursor-pointer">
              <CircleX onClick={onClose} />
            </div>
          </div>
          {isSignature ? (
            <div className="">
              <img
                src={signatureImg?.url}
                alt={`Slide`}
                className="w-full h-full object-cover rounded-lg"
              />
              <div className="flex justify-between mt-5 w-full">
                <div className="w-[49%]">
                  <ButtonTag
                    onSubmit={(e) => {
                      setIsSignature(false);
                    }}
                    name="Change"
                    classes="text-sm text-center bg-dangerColor text-white"
                  />
                </div>
                <div className="w-[49%]">
                  <ButtonTag
                    onSubmit={() => {
                      onSubmit(signatureImg)
                    }}
                    name="Done"
                    classes="text-sm text-center bg-themeColor text-white"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div>
              <Signature
                signatureLoader={signatureLoading}
                signatureFile={(sign) => {
                  ConvertSignatureToUrl(sign);
                }}
              />
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default SignPopup;
